const VERIFICATION_LABELS = {
  unverified: "Unverified",
  source_reported: "Source-reported",
  community_confirmed: "Community-confirmed",
  official_confirmed: "Officially confirmed",
  disputed: "Disputed",
  archived: "Archived",
};

const MODERATION_LABELS = {
  pending: "Pending review",
  approved: "Approved",
  rejected: "Rejected",
  needs_review: "Needs review",
  archived: "Archived",
};

const RUN_STATUS_LABELS = {
  completed: "Completed",
  completed_with_errors: "Completed with errors",
  failed: "Failed",
  started: "Started",
  running: "Running",
};

const INFRASTRUCTURE_TYPE_LABELS = {
  hospital: "Hospital",
  clinic: "Clinic",
  school: "School",
  university: "University",
  police_station: "Police station",
  fire_station: "Fire station",
  shelter: "Shelter",
  community_center: "Community center",
  pharmacy: "Pharmacy",
  transit_station: "Transit station",
  transit_hub: "Transit hub",
  utility: "Utility",
  other: "Other",
};

export function verificationLabel(status) {
  if (!status) {
    return "Unverified";
  }

  return VERIFICATION_LABELS[status] || status.replace(/_/g, " ");
}

export function moderationLabel(status) {
  if (!status) {
    return null;
  }

  return MODERATION_LABELS[status] || status.replace(/_/g, " ");
}

export function runStatusLabel(status) {
  if (!status) {
    return "Unknown";
  }

  return RUN_STATUS_LABELS[status] || status.replace(/_/g, " ");
}

export function infrastructureTypeLabel(type) {
  if (!type) {
    return "Infrastructure";
  }

  return INFRASTRUCTURE_TYPE_LABELS[type] || type.replace(/_/g, " ");
}

export function formatAlertType(alertType) {
  if (!alertType) {
    return null;
  }

  return alertType.replace(/_/g, " ");
}

export function isMockOrLocalSource(displaySource) {
  if (!displaySource) {
    return false;
  }

  const normalized = displaySource.toLowerCase();
  return normalized.includes("mock") || normalized.includes("local");
}

export function formatCompletedTime(isoString) {
  if (!isoString) {
    return "—";
  }

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) {
    return "—";
  }

  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatRelativeTime(isoString) {
  if (!isoString) {
    return null;
  }

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const diffMs = Date.now() - date.getTime();
  const absMs = Math.abs(diffMs);
  const minutes = Math.floor(absMs / 60000);
  const hours = Math.floor(absMs / 3600000);
  const days = Math.floor(absMs / 86400000);

  if (minutes < 1) {
    return diffMs >= 0 ? "just now" : "in a moment";
  }

  if (minutes < 60) {
    return diffMs >= 0 ? `${minutes}m ago` : `in ${minutes}m`;
  }

  if (hours < 48) {
    return diffMs >= 0 ? `${hours}h ago` : `in ${hours}h`;
  }

  if (days < 14) {
    return diffMs >= 0 ? `${days}d ago` : `in ${days}d`;
  }

  return formatCompletedTime(isoString);
}
